import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export const Route = createFileRoute("/version")({
  component: RouteComponent,
});

const CLIENT_BUILD_TIME =
  typeof __MIAPARLE_BUILD_TIMESTAMP__ === "number"
    ? __MIAPARLE_BUILD_TIMESTAMP__
    : -1;

function RouteComponent() {
  const [serverStartTime, setServerStartTime] = useState<number | "loading...">(
    "loading...",
  );
  const [serverCommit, setServerCommit] = useState("loading...");

  useEffect(() => {
    const controller = new AbortController();

    const load = async () => {
      try {
        const response = await fetch("/api/version", {
          cache: "no-store",
          signal: controller.signal,
        });
        const payload = (await response.json()) as {
          serverStartedAt?: number;
          commit?: string;
        };
        setServerStartTime(payload.serverStartedAt ?? -1);
        setServerCommit(payload.commit ?? "unknown");
      } catch {
        setServerStartTime(-1);
        setServerCommit("unknown");
      }
    };

    void load();
    return () => controller.abort();
  }, []);

  return (
    <pre className="whitespace-pre-wrap p-6 text-lg">
      {`client build time : ${CLIENT_BUILD_TIME}
server start time : ${serverStartTime}
server commit     : ${serverCommit}`}
    </pre>
  );
}
